import { z } from 'zod';
import { SweetShopArticleModelSchema } from 'entities/sweet-shop-article';
import { GetSweetShopArticleByUidApiResponseSchema } from '../store';

export const createSweetShopArticleFromGetSweetShopArticleByUidApiResponse = (
    (response: z.infer< typeof GetSweetShopArticleByUidApiResponseSchema>) => (
        SweetShopArticleModelSchema.parse({
            uid: response.data.slug,
            name: response.data.name,
            description: response.data.description,
            weight: response.data.weight,
            price: response.data.price,
            images: response.data.images?.map(({ url }) => ({
                url,
            })),
            currency: response.data.currency && {
                name: response.data.currency.name,
                abbreviation: response.data.currency.abbreviation,
            },
            category: response.data.category && {
                uid: response.data.category.slug,
            },
            tags: response.data.tags?.map(({
                name: name2,
            }) => ({
                name: name2,
            })),
            elements: response.data.elements?.map(({
                name: name2,
                value,
                meassure,
            }) => ({
                name: name2,
                value,
                meassure,
            })),
            recommendations: response.data.recommendations?.map(({
                slug: slug2,
                name: name2,
                weight: weight2,
                price: price2,
                images: images2,
                currency: currency2,
            }) => ({
                uid: slug2,
                name: name2,
                weight: weight2,
                price: price2,
                image: images2?.[0] && {
                    url: images2?.[0].url,
                },
                currency: currency2 && {
                    name: currency2.name,
                    abbreviation: currency2.abbreviation,
                },
            })),
        })
    )
);
